import { FC, useContext } from "react";
import { FAX_NUMBER, PHONE_NUMBER } from "../../../constants/contact";
import { ContactAndSafetyInfoProps } from "../../contactAndSafetyInfo/types";

import { AuthContext } from "src/context/authContext";
import { FooterContext } from "src/context/footerContext";

const ManufacturerContactAndSafetyInfo: FC<ContactAndSafetyInfoProps> = ({ alignText, textColor }): JSX.Element => {
  const { isUserAuthorized } = useContext(AuthContext);
  const {changeAccordianVisibility} =  useContext(FooterContext)
  return (
    <>
      <div className={`${alignText} my-3 mt-0`}>
      <button
          type="button"
          onClick={changeAccordianVisibility}
          className={`btn btn-link p-0 ${!isUserAuthorized ? `text-${textColor}` : ''} ${!isUserAuthorized ? `link-${textColor}` : ''} link-underline-${isUserAuthorized ? 'primary' : textColor === 'black' ? 'dark' : 'light'}`}
        >
          Important Safety Information
        </button>
        <span className={`text-${textColor}`}> | </span>
        <a
          href="/assets/EuflexxaPI.pdf"
          target="_blank"
          className={`btn btn-link p-0 ${!isUserAuthorized ? `text-${textColor}` : ''} ${!isUserAuthorized ? `link-${textColor}` : ''} link-underline-${isUserAuthorized ? 'primary' : textColor === 'black' ? 'dark' : 'light'}`}
        >
          Full Prescribing Information
        </a>
      </div>

      <div className={`${alignText} mb-3`}>
          Phone: {PHONE_NUMBER} | Fax: {FAX_NUMBER}
      </div>
    </>
  );
};

export default ManufacturerContactAndSafetyInfo;
